module.exports = __webpack_public_path__ + "static/map-499f06b6d3cefd95918e568108fd84af.png";